module.exports = __webpack_public_path__ + "media/images/new_home/large-logo-c908324690302d3b6ed8cd3b68a59992.png";